

























































































































import { Component, Prop } from 'nuxt-property-decorator'
import { BookbindingTargetMagazineCollection, SystemCode } from '@/api'
import { Col, DataTable } from '@/components/molecules/DataTable'
import RecycleScroller from '@/components/molecules/RecycleScroller/RecycleScroller.vue'
import { CollectionStatus } from '@/types'

export interface BibliographySearchResultsAuthorityTableItem
  extends BookbindingTargetMagazineCollection {
  isSelected: boolean
}

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'check',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'collectionNo',
        headerText: '資料番号'
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'volume',
        headerText: '巻'
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'volumeNumber',
        headerText: '号'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'volumeTotal',
        headerText: '通巻'
      }
    ]
  },
  {
    width: '11',
    resizable: true,
    items: [
      {
        name: 'volumeDateLabel',
        headerText: '年月日号'
      }
    ]
  },
  {
    width: '16',
    resizable: true,
    items: [
      {
        name: 'volumeSpecial',
        headerText: '特別区分'
      }
    ]
  },
  {
    width: '27',
    resizable: true,
    items: [
      {
        name: 'displayContent',
        headerText: '内容'
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    items: [
      {
        name: 'collectionStatus',
        headerText: '状態'
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    items: [
      {
        name: 'holdingBranchCode',
        headerText: '所蔵館'
      }
    ]
  }
]

@Component({
  components: { RecycleScroller }
})
export default class BookbindingCollectionsTable extends DataTable {
  @Prop({
    type: Array,
    required: true
  })
  items!: BibliographySearchResultsAuthorityTableItem[]

  allSelect: boolean = false

  get showCols(): Col[] {
    return COLS
  }

  isCollectionStatusShelf(collectionStatus: SystemCode): boolean {
    return collectionStatus.code === CollectionStatus.Shelf
  }

  onClickTableRow(index: number): void {
    if (this.isCollectionStatusShelf(this.items[index].collectionStatus)) {
      this.items[index].isSelected = !this.items[index].isSelected
    }
  }

  onChangeAllSelect(): void {
    this.allSelect = !this.allSelect
    this.items.forEach(item => {
      if (this.isCollectionStatusShelf(item.collectionStatus)) {
        item.isSelected = this.allSelect
      }
    })
  }
}
